import { Color, Markdown, Typography } from "@elearning-platform/ui";
import styled, { css } from "styled-components";
import { prop } from "ramda";

import { Float as FloatBase } from "../../../../components/float/float.component";
import { styleWhenTrue } from "../../../../helpers/rendering";
import { Color as OldColors, FontWeight, Media } from "../../../../theme";

export const Container = styled.div`
  background-color: ${OldColors.white};
  padding: 25px;
  z-index: 1;

  ${styleWhenTrue(prop("$withBg"), css`
    background-color: ${OldColors.white};
  `)}

  ${({ $isModernLesson, $withBg }) => $isModernLesson && $withBg && `background-color: ${Color.Gray100}`};

  ${Media.tablet`
    width: 44%;
    margin-left: 20px;
    background-color: ${OldColors.transparent};

    ${styleWhenTrue(prop("$withBg"), css`
      background-color: ${OldColors.white};
    `)}

    ${({ $isModernLesson, $withBg }) => $isModernLesson && $withBg && `background-color: ${Color.Gray100}`};

    ${styleWhenTrue(prop("$isInteraction"), css`
      width: 100%;
      margin-left: 0;
    `)}
  `}

  ${styleWhenTrue(prop("$fluidHeight"), css`
    height: 100%;
  `)}
`;

export const Title = styled.p`
  font-weight: ${FontWeight.Bold};
  font-size: 24px;
  line-height: 32px;

  ${styleWhenTrue(prop("$big"), css`
    font-size: 24px;
    line-height: 32px;

    ${Media.tabletWide`
      font-size: 38px;
      line-height: 52px;
    `}
  `)}
`;

export const Separator = styled.div`
  height: 2px;
  background-color: ${() => OldColors.brandBasic};
  margin: 15px 0 25px;
`;

export const Subtitle = styled.p`
  font-size: 18px;
  line-height: 28px;

  b {
    font-weight: ${FontWeight.Bold};
  }

  em {
    font-style: italic;
  }
`;

export const SubtextWrapper = styled(Typography)`
  margin-top: 24px;
`;

export const Subtext = styled(Markdown)`
  color: ${Color.Gray600};
`;

export const HelperText = styled.p`
  margin-top: 10px;
  font-size: 15px;
  line-height: 20px;
  color: ${OldColors.gray9};
`;

export const CounterWrapper = styled.p`
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 20px;
`;

export const CurrentSlide = styled.span`
  font-weight: ${FontWeight.SemiBold};
`;

export const Float = styled(FloatBase)`
  margin-top: 30px;
`;

export const DisclaimerWrapper = styled.div`
  background-color: ${Color.Gray100};
  padding: 12px 20px 20px;
`;

export const BoxWithPadding = styled.div`
  padding: 24px 0;
`;

export const AccordionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 20px 0;
`;

export const StyledTypography = styled(Typography)`
  color: ${Color.Gray600};
  margin-top: 8px;
`;

export const AttachmentBoxWrapper = styled.div`
  margin-top: 24px;
`;
